import React, { useEffect, useState } from 'react';
import { MeetingType, UIRound } from 'types';
import classNames from 'classnames';

interface Props {
	rounds: UIRound[];
	setSelectedRound: (val: string) => void;
	setIsAIRoundSelected: (val: boolean) => void;
	selectedRound: string;
	showMockTestOnly?: boolean;
	interviewType?: MeetingType | null;
}

export const RecommendRound = ({
	rounds,
	setSelectedRound,
	selectedRound,
	setIsAIRoundSelected,
	showMockTestOnly,
	interviewType,
}: Props) => {
	const [filteredRounds, setFilteredRounds] = useState<UIRound[]>([]);

	useEffect(() => {
		const filtered =
			rounds?.filter(
				el =>
					(!interviewType ||
						(interviewType === MeetingType.Assessment
							? el?.meetingType === MeetingType.Assessment
							: el?.meetingType !== MeetingType.Assessment)) &&
					(showMockTestOnly ? el.isMock : !el.isMock),
			) ?? [];

		setFilteredRounds(filtered);

		if (filtered?.length) {
			setSelectedRound(filtered[0]?._id);
			setIsAIRoundSelected(
				filtered[0]?.roundTemplate.isAIInterviewTemplate || filtered[0]?.meetingType === MeetingType.Assessment,
			);
		}
	}, [rounds, interviewType, showMockTestOnly]);

	return (
		<div className="flex flex-col gap-2">
			<p className="text-[15px] dark:text-[#C7C9D9] font-[500]">Select a round</p>
			<div className="w-full flex flex-wrap gap-4">
				{filteredRounds.length ? (
					filteredRounds.map(r => (
						<div
							key={r._id}
							onClick={() => {
								setSelectedRound(r._id);
								setIsAIRoundSelected(r.roundTemplate.isAIInterviewTemplate || r.meetingType === MeetingType.Assessment);
							}}
							className={classNames(
								'flex px-[12px] py-[8px] cursor-pointer rounded-lg border w-max',
								selectedRound === r._id ? 'bg-[#18222D] border border-[#7777E7]	text-gray-50' : 'bg-gray-50	text-black',
							)}
						>
							<div className="pl-1.5">{r.roundTemplate.title}</div>
						</div>
					))
				) : (
					<div>No tech stacks found for your experience</div>
				)}
			</div>
		</div>
	);
};
